import FooterContainer from './components/FooterContainer'

export default FooterContainer
